export const locales = ["en", "nl", "fr", "es", "de"] as const;

export type Locale = (typeof locales)[number];
